import React, { memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getEnv } from 'utils';
import { useDispatchContext, initialState } from 'context';
import { logoutUser, changeProfileMenuStep } from 'store';
import { toast } from 'lib';
import { UiPopover } from 'ui-components';
import { DesktopPopover, MobileDrawer, TabletPopover } from './components';
import defaultAvatar from './../../../../assets/img/default-avatar.svg';
import { StyledUserProfile } from './UserProfile.styles';

const UserProfile = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(
    (state) => state.accountReducer.currentUser?.user
  );
  const [open, setOpen] = useState(false);
  const dispatchContext = useDispatchContext();
  const avatar = currentUser?.avatar
    ? `${getEnv('REACT_APP_BASE_API')}/user/avatars/${currentUser?.avatar}`
    : defaultAvatar;
  const isMobile = window.innerWidth <= 600;
  const [anchorEl, setAnchorEl] = useState(null);

  /**
   * خروج از سامانه و هدایت به صفحه لاگین
   */
  const logout = async () => {
    try {
      await dispatch(logoutUser()).unwrap();
      dispatchContext({ type: 'logout', ...initialState });
      navigate('/login');
    } catch (error) {
      toast({
        title: t('users:error.logout.title'),
        description: t('users:error.logout.description'),
        type: 'error',
      });
    }
  };

  const toggleProfileMenu = () => {
    if (!open) {
      dispatch(changeProfileMenuStep('step_1'));
      setOpen(true);
      return;
    }
    setOpen(false);
  };

  const handleToggle = (event) => {
    setAnchorEl(event.currentTarget);
    if (!open) {
      dispatch(changeProfileMenuStep('step_1'));
      setOpen(true);
      return;
    }
    setOpen(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setOpen(false);
  };

  return (
    <StyledUserProfile>
      <div className='user-profile flex' data-testid='header-user-profile'>
        <img
          id='avatar'
          className='avatar'
          src={avatar}
          onClick={handleToggle}
          alt=''
        />
        {!isMobile && (
          <UiPopover
            id={open ? 'userProfilePopover' : undefined}
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            paperStyles={{ marginTop: '12px' }}
          >
            <DesktopPopover
              avatar={avatar}
              user={currentUser}
              logout={logout}
              close={() => setOpen(false)}
            />
            <TabletPopover
              avatar={avatar}
              user={currentUser}
              logout={logout}
              close={() => setOpen(false)}
            />
          </UiPopover>
        )}
        <MobileDrawer
          avatar={avatar}
          user={currentUser}
          logout={logout}
          onToggle={toggleProfileMenu}
          close={() => setOpen(false)}
          open={open}
        />
      </div>
    </StyledUserProfile>
  );
};

export default memo(UserProfile);
